import PlisseCalcPlisse from '../components/calc/plisse/CalcPlisse.svelte';
import PlisseCalcSlimPro from '../components/calc/plisse/CalcSlimPro.svelte';
import PlisseCalcSlimProShtora from '../components/calc/plisse/CalcSlimProShtora.svelte';
import PlisseCalcPlugin from '../components/calc/plisse/CalcPlugin.svelte';
import PlisseCalcPluginVSN from '../components/calc/plisse/CalcPluginVSN.svelte';
import PlisseCalcCommon from '../components/calc/plisse/CalcCommon.svelte';
import PlisseCalcRazdvijka from '../components/calc/plisse/CalcRazdvijka.svelte';
import PlisseCalcPlisse16 from '../components/calc/plisse/CalcPlisse16.svelte';
import PlisseCalcO2 from '../components/calc/plisse/CalcO2.svelte';
import AdamCalcSoft from '../components/calc/adam/CalcSoft.svelte';
import AdamCalcSlaydors4 from '../components/calc/adam/CalcSlaydors4.svelte';
import PlisseCalcSmart from "../components/calc/plisse/CalcSmart.svelte";
import PlisseCalcSmartMihail from "../components/calc/moskitos/CalcSmart-Tkan.svelte";
import PlisseCalcSlim from "../components/calc/plisse/CalcSlim.svelte";
import PlisseCalcSlimMihail from '../components/calc/plisse/CalcSlimMihail.svelte';
import PlisseCalc42DV from '../components/calc/plisse/Calc42DV.svelte';
import PlisseCalc32DV from '../components/calc/plisse/Calc32DV.svelte';
import PartMaterials from '../components/parts/Materials.svelte';
import PartMaterialsDil from '../components/parts/MaterialsDil.svelte';
import PartMaterialsVisible from '../components/parts/MaterialsVisible.svelte';
import PartPrice from '../components/parts/Price.svelte';
import PartPrice2 from '../components/parts/Price2.svelte';
import PartPrice3 from '../components/parts/Price3.svelte';
import PartPriceGiliatina from '../components/parts/PriceGiliatina.svelte';
import CalcMounting from '../components/calc/CalcMounting.svelte';
import AdamCalcMounting from '../components/calc/adam/CalcMounting.svelte';
import CalcZanzar from '../components/calc/adam/CalcZanzar.svelte';
import AdamCalcSlaydorsGluh from '../components/calc/adam/CalcSlaydorsGluh.svelte';
import AdamCalcSlaydors6 from '../components/calc/adam/CalcSlaydors6.svelte';
import AdamCalcSlaydorsGiliatina from '../components/calc/adam/CalcSlaydorsGiliatina.svelte';
import CalcMayatnik from '../components/calc/adam/CalcMayatnik.svelte';
import CalcPodokonnik from '../components/calc/adam/CalcPodokonnik.svelte';
import CalcRilly from '../components/calc/adam/CalcRilly.svelte';
import CalcUSN from '../components/calc/plisse/CalcUSN.svelte';
import CalcISOTRA from '../components/calc/adam/CalcIsotraHit.svelte';
import CalcVals from '../components/calc/adam/CalcVals.svelte';
import CalcVertik from '../components/calc/adam/CalcVertik.svelte';
import CalcJaluziPlisse from '../components/calc/adam/CalcJaluziPlisse.svelte';
import CalcVals2 from '../components/calc/adam/CalcVals2.svelte';
import CalcSlaydLux from '../components/calc/adam/CalcSlaydLux.svelte';
import CalcPluginCommon from '../components/calc/adam/CalcPluginCommon.svelte';
import PlisseCalcPlisse16New from "../components/calc/plisseltd/CalcPlisse16New.svelte";
import PlisseCalcAlumPro from "../components/calc/plisse/CalcAlumPro.svelte";
import CalcPacking from "../components/calc/CalcPacking.svelte";
import PlisseCalcShtory from "../components/calc/plisse/CalcPlisseShtory.svelte";
import PlisseCalcShtory53 from "../components/calc/plisse/CalcPlisseShtory53.svelte";
import CalcNakidka54 from "../components/calc/nakidka/CalcNakidka54.svelte";
import PlisseCalcSlimProMSPlisse from '../components/calc/plisse/CalcSlimProMSPlisse.svelte';
import CalcMagnum from '../components/calc/adam/CalcMagnum.svelte';
import CalcElektroKarniz from '../components/calc/adam/CalcElektroKarniz.svelte';
import CalcLift from '../components/calc/adam/CalcLift.svelte';
import CalcVertikJaluzi from '../components/calc/adam/CalcVertikJaluzi.svelte';
import PlisseCalcPlissePlugin from "../components/calc/plisse/CalcPlissePlugin.svelte";
import CalcFurnituraPlugin from "../components/calc/adam/CalcFurnitura.svelte";
import CalcPriceSimple from "../components/parts/PriceSimple.svelte";
import CalcRimskie from "../components/calc/adam/CalcRimskie.svelte";
import PlisseCalcPlisse16NewMihail from "../components/calc/plisse/CalcPlisse16NewMihail.svelte";
import PlisseCalcShtoryMihail from '../components/calc/plisse/CalcPlisseShtoryMihail.svelte';
import PlisseCalcPlisseVstavnaya from "../components/calc/plisse/CalcPlisseVstavnaya.svelte";

let list = [];
let logo = null;
let precision = null;
let loggerUrl = null;

if (APP_TYPE === 'axis-one') {
    logo = 'axis.png';
    precision = 1;
    loggerUrl = 'https://logger.axis-erp.ru';

    list.push({
        title: 'Плиссе 16мм NEW',
        calc: 'Плиссе 16мм New',
        alt: {42: 'Плиссе 25 мм'},
        img: '/img/plisse/plisse16.jpeg',
        description: 'Калькулятор Плиссе 16мм NEW',
        link: 'плиссе-16new',
        component: PlisseCalcPlisse16New,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            vStrukture: 95,

        }


    });
/*форк для Михаила*/
    list.push({
        title: 'Плиссе 16мм-new',
        calc: 'Плиссе 16мм-new',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Калькулятор Плиссе 16мм NEW',
        link: 'плиссе-16-new',
        component: PlisseCalcPlisse16NewMihail,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            vStrukture: 95,

        }
    });

    list.push({
        title: 'Плиссе',
        calc: 'Плиссе',
        img: '/img/plisse/axis-plisse/plisse.jpg,/img/plisse/axis-plisse/plisse2.jpg,/img/plisse/axis-plisse/plisse3.jpg,/img/plisse/axis-plisse/plisse4.jpg,/img/plisse/axis-plisse/plisse5.jpg,/img/plisse/axis-plisse/plisse6.jpg,/img/plisse/axis-plisse/plisse7.jpg,/img/plisse/axis-plisse/plisse8.jpg',
        description: 'Плиссированная сетка со складками шириной 25мм. Профиль: 40-30 мм. Максимальные размеры ширина 6 м. и высота 3м.',
        link: 'плиссе',
        component: PlisseCalcPlisse,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'SlimPro',
        calc: 'SlimPro',
        alt: {40: 'МС Плиссе'},
        img: '/img/plisse/axis-plisse/slimpro.jpeg,/img/plisse/axis-plisse/slimpro2.jpg,/img/plisse/axis-plisse/slimpro3.jpg,/img/plisse/axis-plisse/slimpro4.jpg',
        description: 'Плиссе для средних размера проемов. Профиль: 25-25 мм. Ширина волны сетки: 14-16 мм',
        link: 'slimpro',
        component: PlisseCalcSlimPro,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Smart',
        calc: 'Smart',
        alt: {42: 'Плиссе 40 мм', 43: 'PRO 40'},
        img: '/img/plisse/setkipro/setki.pro_smart.png',
        description: 'Плиссе для средних размера проемов. Профиль: 40-27 мм. Ширина волны сетки:  16 мм',
        link: 'smart',
        component: PlisseCalcSmart,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антимошка',
                'Антипыль',
            ],

        }
    });

    list.push({
        title: 'Москитная система Slim',
        calc: 'Slim',
        alt: {43: 'SLIM 20'},
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль: 25x18 мм. Длина волны сетки: 12-14 мм. Для проёмов размеров ШхВ 1000х2000 мм',
        link: 'slim',
        component: PlisseCalcSlim,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антимошка',
                'Антипыль',
            ],
            max: {
                width: 2100,
                height: 2200
            }

        }
    });




    list.push({
        title: 'Вставная сетка',
        calc: 'Вставная',
        img: '/img/plisse/setkipro/setki.pro_vstavnaya.png',
        description: 'Легкая и быстрая установка подходит для оконного фильтра',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            PartMaterials,

        ],
    });

    list.push({
        title: 'Вставная сетка VSN',
        calc: 'VSN',
        img: '/img/plisse/setkipro/setki.pro_vstavnaya.png',
        description: 'Легкая и быстрая установка подходит для оконного фильтра',
        link: 'vsn',
        component: PlisseCalcPluginVSN,
        components: [
            PartPrice,
            PartMaterials,

        ],
    });

    list.push({
        title: 'Рамочная сетка',
        calc: 'Обычная',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Рамочная москитная сетка на кронштейнах или крючках',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Плиссе 16мм',
        calc: 'Плиссе 16мм',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Сетка плиссе со складками шириной 16мм. Максимальные размеры ширина 3 м. и высота 2.5м',
        link: 'плиссе-16',
        component: PlisseCalcPlisse16,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 6000,
                height: 3000,
            },
        }
    });

    list.push({
        title: 'Защита нового поколения О2',
        calc: 'Детская',
        img: '/img/plisse/o2.jpeg',
        description: 'Прозрачные решетки (ламели) защитят от выпадения ребенка',
        link: 'защита-о2',
        component: PlisseCalcO2,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Мягкие окна',
        calc: 'Мягкие окна',
        img: '/img/мягкие-окна.jpg',
        description: 'Гибкие окна, прозрачные шторы ПВХ для беседок, террас, веранд, балконов',
        link: 'мягкие-окна',
        component: AdamCalcSoft,
        components: [
            PartPrice,
            AdamCalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Система Слайдорс 4',
        calc: 'Слайдорс 4', // Cлайдорс 4
        img: '/img/slaydors/razdvizhnoe-osteklenie-sistema-panorama.jpg',
        description: 'Система Слайдорс 4 - безрамное остекление',
        link: 'слайдорс-4',
        component: AdamCalcSlaydors4,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 30000,
                height: 4000,
            },
            recomend: {
                width: 20000,
                height: 3000,
            },
        }
    });

    list.push({
        title: 'Система Слайдорс 6',
        calc: 'Слайдорс 6', // Cлайдорс 6
        img: '/img/slaydors/razdvizhnoe-osteklenie-sistema-panorama.jpg',
        description: 'Система Слайдорс 6 - безрамное остекление',
        link: 'слайдорс-6',
        component: AdamCalcSlaydors6,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 50000,
                height: 5000,
            },
            recomend: {
                width: 30000,
                height: 3000,
            },
        }
    });

    list.push({
        title: 'Система Гильотина',
        calc: 'Гильотина',
        img: '/img/slaydors/gilotinnoe-osteklenie.jpg',
        description: 'Остекление системой Гильотина',
        link: 'система-гильотина',
        component: AdamCalcSlaydorsGiliatina,
        components: [
            PartPriceGiliatina,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Система глухое остекление',
        calc: 'Cлайдорс глух.',
        img: '/img/slaydors/gluhsteklo.jpeg',
        description: 'Глухое остекление в системе Слайдорс',
        link: 'слайдорс-глух',
        component: AdamCalcSlaydorsGluh,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Раздвижная Проведал',
        calc: 'Раздвижка',
        img: '/img/PROVEDAL.jpg',
        description: 'Сдвижная противомоскитная сетка устанавливается с внутренней и внешней стороны на верхних и нижних направляющих.',
        link: 'раздвижка-проведал',
        component: PlisseCalcRazdvijka,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Дверная рамочная сетка',
        calc: 'Дверная',
        img: '/img/plisse/common.jpg',
        description: 'Дверная рамочная сетка 42 профиль',
        link: 'дверная-42профиль',
        component: PlisseCalc42DV,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит':'Антрацит',
                'Цветной': 'Цветной',
            }
        }
    });


    list.push({
        title: 'Дверная рамочная сетка',
        calc: 'Дверная 32мм',
        img: '/img/other/15947432_01.webp',
        description: 'Дверная рамочная сетка 32 профиль',
        link: 'дверная-32профиль',
        component: PlisseCalc32DV,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит':'Антрацит',
                'Цветной': 'Цветной',
            }
        }
    });

    list.push({
        title: 'Москитная система ZANZAR',
        calc: 'ZANZAR',
        img: '/img/zanzar.jpg',
        description: 'Рулонная москитная сетка с боковыми направляющими',
        link: 'zanzar',
        component: CalcZanzar,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 1600,
                height: 2400
            },
            recomend: {
                width: 1600,
                height: 2400

            },
        }
    });

    list.push({
        title: 'Цельностеклянная дверь',
        calc: 'Цельностеклянные двери',
        img: '/img/mayatnik/pict.jpg',
        description: 'Маятниковая система цельностеклянные двери',
        link: 'Цельностеклянная дверь',
        component: CalcMayatnik,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 10000,
                height: 5000
            },
            recomend: {
                width: 10000,
                height: 5000

            },

        }
    });


    list.push({
        title: 'Подоконники',
        calc: 'Подоконник',
        img: '/img/podokonnik.jpg',
        description: 'Подоконники разных видов',
        link: 'Подоконник',
        component: CalcPodokonnik,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 10000,
                height: 4000
            },
            recomend: {
                width: 10000,
                height: 5000

            },
        }
    });

    list.push({
        title: 'Губка',
        calc: 'Rilly',
        img: '/img/logo/Logo_Rilly.svg',
        description: 'Губки для мытья',
        link: 'Губка',
        component: CalcRilly,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Сетка USN',
        calc: 'USN',
        img: '/img/plisse/usn.mp4',
        description: 'Сетка USN',
        link: 'usn',
        component: CalcUSN,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });


    list.push({
        title: 'Слайд-Люкс',
        calc: 'СлайдЛюкс',
        img: '',
        description: 'Системы Слайд-Люкс',
        link: 'slaydlux',
        component: CalcSlaydLux,
        components: [
            PartPrice2,
            PartMaterialsVisible,
        ],
    });

    list.push({
        title: 'МС',
        calc: 'МС',
        img: '/img/plisse/vstavms.jpg',
        description: 'Рамочная и вставная москитная сетка',
        link: 'plugin-common',
        component: CalcPluginCommon,
        components: [
            PartPrice3,
            PartMaterials,
        ],
    });


    list.push({
        title: 'Москитная сетка АлюмПро',
        calc: 'АлюмПро',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Профиль 25х17мм. Для алюминиевых окон без сверления 1000х2000мм',
        link: 'алюмпро',
        component: PlisseCalcAlumPro,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Гарфит(RAL7024)': 'Гарфит(RAL7024)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 1000,
                height: 2000
            },
            vStrukture: 101
        }
    });


    list.push({
        title: 'Шторы плиссе',
        calc: 'Шторы плиссе',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Плиссированные ткани, между двумя профилями.',
        link: 'шторы-плиссе',
        component: PlisseCalcShtory,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1200,
                height: 2700

            },
            vStrukture: 104,


            shtorytypes: {
                'Полупрозрачная': 'Полупрозрачная',
                'Dark out': 'Dark out  90% затемнения',
                'СОТЫ (BLACKOUT)': 'Соты Blackout ',
                'СОТА полупрозрачная': 'Соты 65% полупрозрачные',
                'BLACKOUT однослойный': 'BLACKOUT однослойный',
            },

            shtorySotacolor: [
                'антрацит',
                'кремовый',
                'серый',
                'белый',
                'бежевый',
            ],


            shtoryBlackoutcolor: [
                'антрацит',
                'бежевый',
                'серый',
                'белый',
            ],

            komplektcolor: [
                'белый',
                'серый',
                'коричневый',
                'черный',
            ],

            shtoryPoluprozcolor: [
                'Зеленый',
                'Желтый',
                'Оранжевый',
                'голубой',
                'Розовый',
                'Красный',
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'антрацит',
                'мокко',

            ],

            shtorySotaPoluprozcolor: [
                'Белый',
                'Серый',
                'Бежевый',
            ],

            shtoryBlackoutodnosloy: [
                'Белый',
                'Серый',
                'Бежевый',
                'Антрацит',
            ],


            nitcolor: [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'мокко',
                'антрацит',
                'Желтый',
                'Зеленый',
                'Красный',
                'Оранжевый',
                'Розовый',
            ],


            color: {
                'Белый RAL 9016': 'Белый RAL 9016',
                'Серый RAL 7040': 'Серый RAL 7040',
                'Коричневый RAL 8017': 'Коричневый RAL 8017',
                'Серый Антрацит RAL 7016': 'Серый Антрацит RAL 7016',
                'Цветной': 'Цветной',
            }


        }
    });

    /*форк склада 53*/
    list.push({
        title: 'Шторы плиссе',
        calc: 'Шторы плиссе 53',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Плиссированные ткани, между двумя профилями.',
        link: 'шторы-плиссе-53',
        component: PlisseCalcShtory53,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            min: {
                width: 0,
                height: 0
            },
            max: {
                width: 1200,
                height: 2500
            },
            vStrukture: 172,


            shtorytypes: {
                'PLAIN': 'PLAIN',
                'ELEGANCE': 'ELEGANCE',
                'MOON': 'MOON',
                'SHINE': 'SHINE',
                'CANVAS': 'CANVAS',
                'STRiPE': 'STRiPE',
                'MESH': 'MESH',
                'CLASS BAMBOO': 'CLASS BAMBOO',
                'DIMOUT': 'DIMOUT',
                'LINEN': 'LINEN',
                'WIND': 'WIND',
                'VIP BLACKOUT': 'VIP BLACKOUT',
                'HONEYCOMB': 'HONEYCOMB',
                'BLACKOUT': 'BLACKOUT',
            },

            shtorycolors: {
                'PLAIN': ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'],
                'CANVAS': ['01', '02', '03', '04', '05', '06', '07', '08'],
                'LINEN': ['01', '02', '03', '04'],
                'ELEGANCE': ['01', '02', '03', '04', '05'],
                'MESH': ['01', '02', '03'],
                'STRiPE': ['01', '02', '03'],
                'SHINE': ['01', '02', '03', '04', '05', '06'],
                'MOON': ['01', '02', '03', '04', '05', '06'],
                'WIND': ['01', '02', '03', '04', '05'],
                'VIP BLACKOUT': ['01', '02', '03', '04'],
                'CLASS BAMBOO': ['01', '02', '03', '04'],
                'BLACKOUT': ['001', '002', '003', '004', '005', '006'],
                'DIMOUT': ['001', '002', '003', '004'],
                'HONEYCOMB': ['WS001 белый', 'WS002 кремовый', 'WS003 светло-серый', 'WS004 коричневый', 'WS005 антрацит', 'WS006 чёрный', 'WS007 тёмно-серый'],
            },

            shtorySotacolor: [
                'антрацит',
                'кремовый',
                'серый',
                'белый',
                'бежевый',
            ],


            shtoryBlackoutcolor: [
                'антрацит',
                'бежевый',
                'серый',
                'белый',
            ],

            komplektcolor: [
                'Белый RAL 9016',
                'Бежевый RAL 1013',
                'Черный RAL 9005',
                'Серый RAL 7040',
            ],

            shtoryPoluprozcolor: [
                'Зеленый',
                'Желтый',
                'Оранжевый',
                'голубой',
                'Розовый',
                'Красный',
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'антрацит',
                'мокко',

            ],

            shtorySotaPoluprozcolor: [
                'Белый',
                'Серый',
                'Бежевый',
            ],

            shtoryBlackoutodnosloy: [
                'Белый',
                'Серый',
                'Бежевый',
                'Антрацит',
            ],


            nitcolor: [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'мокко',
                'антрацит',
                'Желтый',
                'Зеленый',
                'Красный',
                'Оранжевый',
                'Розовый',
            ],


            color: {
                'Белый RAL 9016': 'Белый RAL 9016',
                'Коричневый RAL 8017': 'Коричневый RAL 8017',
                'Антрацит RAL 7016': 'Антрацит RAL 7016',
                'Серый RAL 7040': 'Серый RAL 7040',
                'Черный RAL 9005': 'Черный RAL 9005',
                'спец.покраска': 'спец.покраска',
            }


        }
    });


    list.push({
        title: 'МС Плиссе',
        calc: 'МС Плиссе',
        img: '/img/plisse/plissems.jpg',
        description: 'Москитная сетка плиссе (гармошка)',
        link: 'мс-плиссе',
        component: PlisseCalcSlimProMSPlisse,
        components: [
            PartPrice3,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 3000,
                height: 2500,
            },
            recomend: {
                width: 2500,
                height: 2300,
            },
        }
    });

    list.push({
        title: 'SlimPro со шторой',
        calc: 'Slim.proShtora',
        img: '/img/plisse/axis-plisse/slimpro.jpeg,/img/plisse/axis-plisse/slimpro2.jpg,/img/plisse/axis-plisse/slimpro3.jpg,/img/plisse/axis-plisse/slimpro4.jpg',
        description: 'Плиссе для средних размера проемов. Профиль: 25-25 мм. Ширина волны сетки: 14-16 мм',
        link: 'slimproshtora',
        component: PlisseCalcSlimProShtora,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Вставная сетка плиссе',
        calc: 'Вставная Плиссе',
        img: '/img/plisse/pluginplisse.mp4',
        description: 'Легкая и быстрая установка сетки плиссе',
        link: 'вставная-плиссе',
        component: PlisseCalcPlissePlugin,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
            },
            vStrukture: 132,


        }
    });

    list.push({
        title: 'Жалюзи Вальс',
        calc: 'Вальс',
        img: '/img/other/vals/vals.jpg',
        description: 'Жалюзи Вальс',
        link: 'вальс-жалюзи',
        component: CalcVals,
        components: [
            PartPrice3,
            PartMaterials,
        ],
    });


    list.push({
        title: 'Жалюзи вертикальные',
        calc: 'Вертикальные',
        img: '/img/other/vals/vertik.jpg',
        description: 'Вертикальные жалюзи',
        link: 'вертикальные-жалюзи',
        component: CalcVertik,
        components: [
            PartPrice3,
            PartMaterials,
        ],
    });



    list.push({
        title: 'Горизонтальные жалюзи Изотра',
        calc: 'Изотра',
        img: '/img/jaluzi/хит тень 2.webp',
        description: 'Горизонтальные жалюзи ISOTRA HIT',
        link: 'isotra',
        component: CalcISOTRA,
        components: [
            PartPrice,
            PartMaterialsDil,
        ],
    });

    list.push({
        title: 'Горизонтальные жалюзи Магнум 25мм',
        calc: 'Магнум',
        img: '/img/jaluzi/м.jpg,/img/jaluzi/магнум.jpg,/img/jaluzi/бок фиксация трос магнум.jpg',
        description: 'Горизонтальные жалюзи Магнум 25мм',
        link: 'magnum',
        component: CalcMagnum,
        components: [
            PartPrice,
            PartMaterialsDil,
        ],
    });

    list.push({
        title: 'Электро карнизы',
        calc: 'Электро карнизы',
        img: '/img/other/elktrokarniz/icon.jpg',
        description: 'Электро карниз',
        link: 'elektrokarniz',
        component: CalcElektroKarniz,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });


    list.push({
        title: 'Лифт система',
        calc: 'Лифт система',
        img: '/img/other/elktrokarniz/lift2.jpg',
        description: 'Лифт система',
        link: 'lift-sistem',
        component: CalcLift,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });


    list.push({
        title: 'Вертикальные жалюзи',
        calc: 'Вертикальные жалюзи',
        img: '',
        description: 'Вертикальные жалюзи',
        link: 'vertikjaluzi',
        component: CalcVertikJaluzi,
        components: [
            PartPrice,
            PartMaterialsDil,
        ],
    });

    list.push({
        title: 'Фурнитура',
        calc: 'Фурнитура',
        img: '/img/jaluzi/furnitura.webp',
        description: 'Продажа фурнитуры',
        link: 'sale-furnitura',
        component: CalcFurnituraPlugin,
        components: [
            PartPrice3,
            PartMaterials, // PartMaterialsPercents,
        ],
    });

    list.push({
        title: 'Жалюзи Вальс',
        calc: 'Жалюзи Вальс',
        img: '/img/other/vals/vals.jpg',
        description: 'Жалюзи Вальс',
        link: 'жалюзи-вальс',
        component: CalcVals2,
        components: [
            PartPrice3,
            PartMaterialsDil,
        ],
    });

    list.push({
        title: 'Жалюзи Плиссе',
        calc: 'Жалюзи Плиссе',
        img: '',
        description: 'Жалюзи Плиссе',
        link: 'жалюзи-плиссе',
        component: CalcJaluziPlisse,
        components: [
            PartPrice,
            PartMaterialsDil,
        ],
    });


    list.push({
        title: 'Римские шторы',
        calc: 'Римские шторы',
        img: '/img/other/rimskie/icon.jpg',
        description: 'Римские шторы',
        link: 'римские-шторы',
        component: CalcRimskie,
        components: [
            PartPrice,
            PartMaterials,
        ],
    });


    /*форк для Михаила*/
    list.push({
        title: 'Шторы-плиссе',
        calc: 'Шторы-плиссе',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Плиссированные ткани, между двумя профилями.',
        link: 'шторы-плиссе-',
        component: PlisseCalcShtoryMihail,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1500,
                height: 2700

            },
            vStrukture: 104,


            shtorytypes: {
                'ПЛИССЕ DARKOUT 90%' : 'ПЛИССЕ DARKOUT 90%',
                'ПЛИССЕ полупрозрачная 60%' : 'ПЛИССЕ полупрозрачная 60%',
                'СОТА BLACKOUT 16мм' :  'СОТА BLACKOUT 16мм',
                'СОТА BLACKOUT 20мм' : 'СОТА BLACKOUT 20мм',
                'СОТА полупрозрачная 16 мм' : 'СОТА полупрозрачная 16 мм',
            },



            shtorySotaPoluprozcolor: [
                'белые kfd07',
                'серые kfd09',
                'бежевый kfd10',
                'коричневый kfd12',
            ],

            shtorySotacolor: [
                'белые kff01',
                'кремовый kff02',
                'коричневый kff06',
                'серый kff07',
            ],
            shtoryBlackoutcolor: [
                'антрацит',
                'бежевый',
                'серый',
                'белый',
            ],

            komplektcolor: [
                'белый',
                'серый',
                'коричневый',
                'черный',
            ],

            shtoryPoluprozcolor: [
                'Зеленый',
                'Желтый',
                'Оранжевый',
                'голубой',
                'Розовый',
                'Красный',
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'антрацит',
                'мокко',
                'Светло-серый 215',
                'Темный серый 218',
                'Черный 219',
                'Кофе 213',
            ],



            shtoryBlackoutodnosloy: [
                'Белый',
                'Серый',
                'Бежевый',
                'Антрацит',
            ],


            nitcolor:   [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'темно-синий',
                'коричневая',
                'мокко',
                'антрацит',
                'Желтый',
                'Зеленый',
                'Красный',
                'Оранжевый',
                'Розовый',
            ],


            color:  {
                'Белый RAL 9016': 'Белый RAL 9016',
                'Серый RAL 7040': 'Серый RAL 7040',
                'Коричневый RAL 8017': 'Коричневый RAL 8017',
                'Серый Антрацит RAL 7016': 'Серый Антрацит RAL 7016',
                'Цветной': 'Цветной',
            }



        }
    });




    list.push({
        title: 'Smart Ткань',
        calc: 'Smart-tkan',
        alt: {42: 'Плиссе 40 мм', 43: 'PRO 40'},
        img: '/img/plisse/setkipro/setki.pro_smart.png',
        description: 'Плиссе для средних размера проемов. Профиль: 40-27 мм. Ширина волны сетки:  16 мм',
        link: 'smart-tkan',
        component: PlisseCalcSmartMihail,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антимошка',
                'Антипыль',
            ],

        }
    });

    list.push({
        title: 'Перегородки с тканью',
        calc: 'Перегородка с тканью',
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль 27*25 мм. Размер до 1600*2500 - 1 створка  \n' +
            'От 1601*2500 - 2 створки',
        link: 'перегородка-с-тканью',
        component: PlisseCalcSlimMihail,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антимошка',
                'Антипыль',
            ],
            max: {
                width: 3000,
                height: 2500
            }

        }
    });



    list.push({
        title: 'Плиссе вставная',
        calc: 'Плиссе вставная',
        img: '/img/plisse/ind3/%D1%81%D1%82%D0%B2%D0%BE%D1%80%D0%BA%D0%B0-%D0%B3%D0%BE%D1%80%D0%B8%D0%B7%D0%BE%D0%BD%D1%82-%D0%B1%D0%B5%D0%BB%D1%8B%D0%B9.jpg',
        description: 'Легкая и быстрая установка сетки плиссе',
        link: 'плиссе-вставная',
        component: PlisseCalcPlisseVstavnaya,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            vStrukture: 163,

        }
    });

    /*калькулятор склада 54*/
    list.push({
        title: 'Универсальная накидка на лобовое стекло автомобиля',
        calc: 'Накидка 54',
        img: '/img/nakidka/nakidka-54.jpg',
        description: 'Накидка на лобовое стекло. В заказ вносится количество.',
        link: 'накидка-54',
        component: CalcNakidka54,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            vStrukture: 176,
            rozn: 800,
            opt: 550,
        }
    });


}

export {list, logo, precision, loggerUrl};

